export const getSectionsForRiskValidation = (sections, currentSection) => {
  const sectionList = Array.isArray(sections) ? sections : []
  if(!currentSection) return sectionList

  const currentSectionIndex = sectionList.findIndex(item => item?.id === currentSection.id)
  if(currentSectionIndex < 0) return [...sectionList, currentSection]

  return sectionList.map((item, index) => index === currentSectionIndex ? currentSection : item)
}

export const isRiskAssignedInTree = (tree, risk, excludedNodeId) => {
  const visited = new WeakSet()

  const visit = (node) => {
    if(!node || typeof node !== 'object') return false
    if(visited.has(node)) return false
    visited.add(node)

    if(Array.isArray(node)) return node.some(visit)

    if((excludedNodeId == null || node.id !== excludedNodeId) && Array.isArray(node.risks) &&
      node.risks.some(item => item === risk || item?.risk === risk)) {
      return true
    }

    return Object.entries(node).some(([key, value]) => key !== 'risks' && visit(value))
  }

  return visit(tree)
}

export const getRiskAssignmentsInTree = (tree, risk) => {
  const visited = new WeakSet()
  const assignments = []

  const visit = (node) => {
    if(!node || typeof node !== 'object' || visited.has(node)) return
    visited.add(node)

    if(Array.isArray(node)) {
      node.forEach(visit)
      return
    }

    if(Array.isArray(node.risks)) {
      node.risks.forEach(item => {
        if(item === risk || item?.risk === risk) assignments.push({ node, item })
      })
    }

    Object.entries(node).forEach(([key, value]) => {
      if(key !== 'risks') visit(value)
    })
  }

  visit(tree)
  return assignments
}
